module.exports = __webpack_public_path__ + "fonts/CircularStd-BookItalic.f1e69e38.otf";